var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('DataListStateful',{attrs:{"title":"Описания товаров","resource":"goods-details","store":"goodsDetails","columns":_vm.columns,"disable-adding":true,"filter-options":_vm.filter,"row-color-fn":_vm.getRowColor}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }